import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UserTypes } from '@constants';
import accountSelectors from '@selectors/account';
import { getCacheAccessToken } from '@services/userService';
import { accountActions } from '@store/actions';

import useActionLoading from './useActionLoading';
import useFetchAction from './useFetchAction';

const useAuth = () => {
    const profile = useSelector(accountSelectors.selectProfile);
    const token = getCacheAccessToken();

    const immediate = !!token && !profile;

    useFetchAction(accountActions.getProfile, { immediate });

    const { loading } = useActionLoading(accountActions.getProfile.type);

    const permissions = profile?.group?.permissions?.map((permission) => permission.action);

    const pcodes = profile?.group?.permissions?.map((permission) => permission.pcode);
    const kind = profile?.kind;
    const isAdmin = useCallback(() => {
        if (kind === UserTypes.ADMIN) return true;
        return false;
    }, [ kind ]);
    const isEmployee = useCallback(() => {
        if (kind === UserTypes.EMPLOYEE) return true;
        return false;
    }, [ kind ]);
    const isCustomer = useCallback(() => {
        if (kind === UserTypes.CUSTOMER) return true;
        return false;
    }, [ kind ]);

    return {
        isAdmin,
        isEmployee,
        isCustomer,
        isAuthenticated: !!profile,
        profile,
        kind,
        permissions,
        pcodes,
        token,
        loading: immediate || loading,
    };
};

export default useAuth;
